/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic-choosed': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<circle pid="0" cx="5.5" cy="5.5" r="4" _stroke="#16B853" stroke-width="3"/>'
  }
})
